import script from "./tab1.vue?vue&type=script&setup=true&lang=ts"
export * from "./tab1.vue?vue&type=script&setup=true&lang=ts"

import "./tab1.vue?vue&type=style&index=0&id=04af2fc8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.13_webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04af2fc8"]])

export default __exports__